import * as React from "react";
import { Layout, Menu } from 'antd';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { partnersRoutes, operationsRoutes, accountMenuItems } from "../routes";
import { AppContext } from "../context/AppContext";
const sukiLogo = require('../assets/images/suki-logo.png')

export const SideMenu: FC = () => {
    const context = React.useContext(AppContext);
    const { onLogout } = context;
    const [routes, setRoutes] = React.useState([])
    const navigate = useNavigate();
    const location = useLocation();

    const onOperationsMenuClick = (event: { key: string }) => {
        navigate(event.key);
    };

    const onAccountMenuClick = async (event: { key: string }) => {
        if(event.key === '/faqs') {
            window.open('https://www.sukiadvantage.com/help-center', '_blank');
        } else {
            onLogout()
        }
    };

    React.useEffect(() => {
        const menuItems = localStorage.getItem('accountType') === 'partner' ? partnersRoutes : operationsRoutes;
        setRoutes((prevRoutes) => {
            if (JSON.stringify(prevRoutes) !== JSON.stringify(menuItems)) {
                return menuItems;
            }
            return prevRoutes;
        });
    }, []);


    return (
        <Layout.Sider>
        <div className="max-h-[42px] flex my-[42px] px-4">
            <img src={sukiLogo} alt="" className="h-[42px] w-[213px]" />
        </div>
        <div className="pl-4 text-header2 font-poppinsMedium text-neutralBlack">SMDC</div>
        <hr className="mb-2"/>
        <Menu
            defaultSelectedKeys={['transactions']}
            items={routes}
            mode="inline"
            onClick={onOperationsMenuClick}
            selectedKeys={[location.pathname]}
        />
        <hr className="mt-2"/>
        <h4 className="pl-4">Account</h4>
        <Menu
            items={accountMenuItems}
            mode="inline"
            onClick={onAccountMenuClick}
            selectedKeys={[]}
        />
        </Layout.Sider>
    );
};